module.exports = __webpack_public_path__ + "img/groupworks@1x.c940a5c0.png";